import { AxiosPromise } from 'axios';
import { instance } from '../../../services';

const attemptVisitorSignOut = (badgeNumber: string): AxiosPromise =>
  instance.post('/api/visitors/signOut', { badgeNumber });

export default attemptVisitorSignOut;
